import { render, staticRenderFns } from "./CommunityForum.vue?vue&type=template&id=646c174e&scoped=true&"
import script from "./CommunityForum.vue?vue&type=script&lang=js&"
export * from "./CommunityForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c174e",
  null
  
)

export default component.exports